import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from "react-toastify";
import reportWebVitals from './reportWebVitals';

import App from './App';
import { store } from "./app/store"

import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import '@moltech/molui/molui.css'
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ToastContainer autoClose={3000} style={{ zIndex: 99999 }}/>
    <App />
  </Provider>
);
reportWebVitals();
